import React, { useState } from 'react';
import { Card, Button, Modal, Form, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import config from '../../config';

const QuickActions = ({ onRefresh }) => {
  const [showDispatchModal, setShowDispatchModal] = useState(false);
  const [dispatchData, setDispatchData] = useState({
    salesOrderId: '',
    vehicleNumber: '',
    driverName: '',
    dispatchDate: new Date().toISOString().split('T')[0]
  });
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState(null);

  const handleDispatchSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      const response = await fetch(`${config.API_BASE_URL}/dispatch-notes`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dispatchData)
      });

      if (response.ok) {
        setAlert({ type: 'success', message: 'Dispatch note generated successfully!' });
        setDispatchData({
          salesOrderId: '',
          vehicleNumber: '',
          driverName: '',
          dispatchDate: new Date().toISOString().split('T')[0]
        });
        onRefresh();
        setTimeout(() => setShowDispatchModal(false), 2000);
      } else {
        throw new Error('Failed to generate dispatch note');
      }
    } catch (error) {
      setAlert({ type: 'danger', message: error.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Card>
        <Card.Header>
          <h6 className="mb-0">Quick Actions</h6>
        </Card.Header>
        <Card.Body>
          <div className="d-grid gap-2">
            <Link to="/sales-orders/create" className="btn btn-primary">
              <i className="fas fa-plus me-2"></i>New Sales Order
            </Link>
            
            <Link to="/new-purchase-order" className="btn btn-success">
              <i className="fas fa-shopping-cart me-2"></i>New Purchase Order
            </Link>
            
            <Link to="/production-requests/create" className="btn btn-warning">
              <i className="fas fa-cogs me-2"></i>Production Request
            </Link>
            
            <Link to="/purchase_requests" className="btn btn-info">
              <i className="fas fa-clipboard-list me-2"></i>Purchase Request
            </Link>
            
            <Button 
              variant="outline-primary" 
              onClick={() => setShowDispatchModal(true)}
            >
              <i className="fas fa-truck me-2"></i>Generate Dispatch Note
            </Button>
            
            <hr className="my-3" />
            
            <div className="small text-muted mb-2">Inventory Actions</div>
            
            <Link to="/inventory" className="btn btn-outline-secondary btn-sm">
              <i className="fas fa-boxes me-2"></i>View Inventory
            </Link>
            
            <Link to="/products" className="btn btn-outline-secondary btn-sm">
              <i className="fas fa-cube me-2"></i>Manage Products
            </Link>
            
            <hr className="my-3" />
            
            <div className="small text-muted mb-2">Reports</div>
            
            <Link to="/reports/inventory" className="btn btn-outline-dark btn-sm">
              <i className="fas fa-chart-bar me-2"></i>Inventory Report
            </Link>
            
            <Link to="/reports/orders" className="btn btn-outline-dark btn-sm">
              <i className="fas fa-chart-line me-2"></i>Orders Report
            </Link>
          </div>
        </Card.Body>
      </Card>

      {/* Dispatch Note Modal */}
      <Modal show={showDispatchModal} onHide={() => setShowDispatchModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Generate Dispatch Note</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleDispatchSubmit}>
          <Modal.Body>
            {alert && (
              <Alert variant={alert.type} className="mb-3">
                {alert.message}
              </Alert>
            )}
            
            <Form.Group className="mb-3">
              <Form.Label>Sales Order ID</Form.Label>
              <Form.Control
                type="text"
                value={dispatchData.salesOrderId}
                onChange={(e) => setDispatchData(prev => ({
                  ...prev,
                  salesOrderId: e.target.value
                }))}
                placeholder="Enter Sales Order ID"
                required
              />
            </Form.Group>
            
            <Form.Group className="mb-3">
              <Form.Label>Vehicle Number</Form.Label>
              <Form.Control
                type="text"
                value={dispatchData.vehicleNumber}
                onChange={(e) => setDispatchData(prev => ({
                  ...prev,
                  vehicleNumber: e.target.value
                }))}
                placeholder="Enter Vehicle Number"
                required
              />
            </Form.Group>
            
            <Form.Group className="mb-3">
              <Form.Label>Driver Name</Form.Label>
              <Form.Control
                type="text"
                value={dispatchData.driverName}
                onChange={(e) => setDispatchData(prev => ({
                  ...prev,
                  driverName: e.target.value
                }))}
                placeholder="Enter Driver Name"
                required
              />
            </Form.Group>
            
            <Form.Group className="mb-3">
              <Form.Label>Dispatch Date</Form.Label>
              <Form.Control
                type="date"
                value={dispatchData.dispatchDate}
                onChange={(e) => setDispatchData(prev => ({
                  ...prev,
                  dispatchDate: e.target.value
                }))}
                required
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowDispatchModal(false)}>
              Cancel
            </Button>
            <Button type="submit" variant="primary" disabled={loading}>
              {loading ? 'Generating...' : 'Generate Dispatch Note'}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default QuickActions;